import React from 'react'
import { connect } from "react-redux";
import Spin from 'antd/lib/spin'

import { initButton } from 'ducks/sign_in/google'
import './style.scss'

import config from './../../../../config'

const GOOGLE_BUTTON_ID = 'google-sign-up-sign-in';
const GOOGLE_CLIENT_ID = config.googleClientId;
const GOOGLE_SIGN_IN_SCOPE = 'profile email';

const mapStateToProps = (state, props) => ({
  isLoading: state.googleSignIn.isLoading,
  onSuccessCallback: props.onSuccessCallback,
  onFailCallback: props.onFailCallback,
  buttonPrefix: props.buttonPrefix,
});

@connect(mapStateToProps)
class GoogleSignIn extends React.Component {
  componentDidMount() {
    this.props.dispatch(
      initButton({
        buttonId: GOOGLE_BUTTON_ID,
        onSignInSuccess: this.onSignInSuccess.bind(this),
        onSignInFailure: this.onSignInFailure.bind(this),
        clientId: GOOGLE_CLIENT_ID,
        scope: GOOGLE_SIGN_IN_SCOPE,
      })
    );
  }
  onSignInSuccess(googleUser) {
    const { onSuccessCallback } = this.props;

    if (onSuccessCallback) {
      const basicProfile = googleUser.getBasicProfile();
      onSuccessCallback({
        idToken: googleUser.getAuthResponse().id_token,
        email: basicProfile.getEmail(),
        name: basicProfile.getName(),
      });
    }

    // чтобы при обновлении страницы НЕ происходил автоматический sign-up/sign-in
    googleUser.disconnect();
  }
  onSignInFailure() {
    const { onFailCallback } = this.props;

    if (onFailCallback) {
      onFailCallback();
    }
  }

  render() {
    const { isLoading, buttonPrefix } = this.props;
    return (
      <Spin spinning={isLoading}>
        <div id={GOOGLE_BUTTON_ID}>
          <span className="icon"></span>
          <span className="buttonText">{buttonPrefix} Google</span>
        </div>
      </Spin>
    );
  }
}

export default GoogleSignIn



// WEBPACK FOOTER //
// ./src/components/CustomComponents/SignIn/Google/index.js